import React, { useState, useEffect } from 'react';

interface DetailsAIEditButtonProps {
  onClick: () => void;
  disabled: boolean;
  className?: string;
  isVertical?: boolean;
}

const DetailsAIEditButton: React.FC<DetailsAIEditButtonProps> = ({
  onClick,
  disabled,
  className = '',
  isVertical = false,
}) => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    // mismatch in server/client rendering for disabled state. force re-render on client to get the correct state
    setIsHydrated(true);
  }, []);

  if (isVertical) {
    return null;
  }
  const isDisabled = !isHydrated ? false : disabled;

  const defaultButtonClassName =
    'bg-gray-900 bg-opacity-100 hover:bg-opacity-90 text-white rounded-lg flex items-center justify-center cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-white transition-all';

  const disabledButtonClassName =
    'bg-gray-200 text-gray-500 rounded-lg flex items-center justify-center cursor-not-allowed';

  return (
    <div className={`mt-1 ${className}`}>
      <div
        className="relative p-0.5 rounded-lg"
        style={{
          background: isDisabled
            ? ''
            : 'linear-gradient(to right, #9952E0, #FAE3D7, #F66E6E)',
        }}
      >
        <button
          disabled={isDisabled}
          className={`${
            isDisabled ? disabledButtonClassName : defaultButtonClassName
          } px-6 py-2 gap-2 w-full font-semibold text-sm md:text-base`}
          data-cy="ai-edit-button"
          onClick={onClick}
        >
          <img
            src={`${__ASSETS_COMMON_IMAGES_URL__}/icons/${
              isDisabled ? 'ai-wand-disabled.svg' : 'ai-wand.svg'
            }`}
            alt=""
            className="w-4 h-4"
          />
          <span className="leading-5 text-nowrap">Edit with AI</span>
        </button>
      </div>
    </div>
  );
};

export default DetailsAIEditButton;
